'use client';

import { Button, Sort } from '@sprd/sprd-component-kit/v2';
import { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';
import { MarketplaceSearchParams } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/utility/validationSchema';
import { SortDrawer } from '@/components/Filters/SortDrawer';
import { useRouter } from '@/i18n/navigation';
import { DEFAULT_SHOWROOM_SORT } from '@/utility/constants';
import { sanitizeQuery } from '@/utility/urls';

type ShowroomSortDrawerProps = {
  slug: string[];
  searchParams: MarketplaceSearchParams;
};

export const ShowroomSortDrawer = ({ slug, searchParams }: ShowroomSortDrawerProps) => {
  const t = useTranslations();
  const router = useRouter();
  const [open, setOpen] = useState<boolean>(false);

  const applySort = useCallback(
    (sort: ProductListPageSort) => {
      setOpen(false);
      router.push({
        pathname: '/shop/user/[[...slug]]',
        params: { slug },
        query: sanitizeQuery({
          ...searchParams,
          sort: sort === DEFAULT_SHOWROOM_SORT ? undefined : sort,
        }),
      });
    },
    [router, searchParams, slug]
  );

  return (
    <>
      <Button
        className="border-none text-sm font-semibold"
        variant="invert"
        onClick={() => setOpen(true)}
        startIcon={<Sort className="size-6" />}
      >
        {t('filter.sort.sortBy')}
      </Button>
      <SortDrawer
        open={open}
        onClose={() => setOpen(false)}
        onChange={applySort}
        selectedOption={searchParams?.sort ?? DEFAULT_SHOWROOM_SORT}
        sortOptions={{
          weight: t('filter.sort.weight'),
          new: t('filter.sort.new'),
        }}
      />
    </>
  );
};
